
import Vue from 'vue'
import catalogService from '@/services/catalog'

export default (files) =>
  catalogService.create('common/file/set_visible_customer', {
    files
  })



// WEBPACK FOOTER //
// ./src/services/workPlan/updateCustomerVisibility.js